var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
        ((_vm.isTextIcon ? 'text-' : '') + "icon"),
        ((_vm.isTextIcon ? 'text-' : '') + "icon-" + _vm.id) ],attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }